import { tv } from 'tailwind-variants';

export const dragContainer = tv({
    slots: {
        base: 'h-full w-full cursor-pointer gap-[14px] p-4 justify-center items-center flex flex-col border border-gray-600 bg-gray-700 rounded-2xl',
    },
    variants: {
        dragOver: {
            true: {
                base: 'bg-primary-600 border-primary-500 border-dashed',
            },
            false: {
                base: '',
            },
        }
    }

});
